import script from "./TemplatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatePage.vue?vue&type=script&setup=true&lang=js"

import "./TemplatePage.vue?vue&type=style&index=0&id=2ef4b167&scoped=true&lang=css"
script.__scopeId = "data-v-2ef4b167"

export default script